import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../shared/_guards/auth.guard';
import { AddUserComponent } from './add-user/add-user.component';
import { UserManagementMainComponent } from './user-management-main/user-management-main.component';
import { UsersListComponent } from './users-list/users-list.component';


const routes: Routes = [
    { path: 'users', component: UserManagementMainComponent, canActivate: [AuthGuard],
      children: [{
        path: '', pathMatch: 'full', component: UsersListComponent, canActivate: [AuthGuard]
      },{
        path: 'editUser/:userId', pathMatch: 'full', component: AddUserComponent, canActivate: [AuthGuard]
      }
      ]
    }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    AuthGuard
  ]
})
export class UserManagementRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/user-management/user-management-routing.module.ts